import { parsePhoneNumber } from 'libphonenumber-js';

// Reads the country out of an E.164 value ("+32473444416" -> BE) so a phone
// input can open under the number's own flag instead of the venue's default.
// Returns null for empty values, values without a "+" prefix, and numbers
// libphonenumber cannot assign to a country; callers then keep their default.
// Mirror of the console helper in otc-gm-console/src/util/phoneFormatter.js.
export function parseStoredPhone(phone) {
  if (!phone) return null;

  const str = phone.toString().trim();
  if (!str.startsWith('+')) return null;

  try {
    const phoneNumber = parsePhoneNumber(str);
    if (phoneNumber && phoneNumber.country) {
      return {
        country: phoneNumber.country,
        nationalNumber: phoneNumber.nationalNumber
      };
    }
  } catch (error) {
    // Not parseable; caller keeps its default country
  }

  return null;
}
